<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-07 11:14:49
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:27:34
-->
<template>
  <mrc_ess_skeleton_loader :loading="loading">
    <v-card>
      <!-- :showEdit='disabled' -->
      <!-- :showEdit="hasBtn('edit-label-translate-internationalization')" -->
      <mrc_ess_iconGroup
        :showEdit="false"
        :showReturn="false"
        :show_del="false"
      >
        <mrc_ess_uploadBtn
          type="0"
          :hrefUrl="uploadUrl"
          v-btnAuth="['upload-label-internationalization-data']"
          class="ml-4"
          table="mrbase_sys_language_version"
          :label="$t('label_Batch_Import')"
        >
        </mrc_ess_uploadBtn>
        <!-- <v-btn
          small
          tag="a"
          depressed
          height="40"
          :href="uploadUrl"
          rounded
          v-btnAuth="['download-label-internationlization-template']"
          class="ml-4 white--text text-button"
          color="primary"
        >
          {{ $t("label_Download_the_template") }}
        </v-btn> -->
        <v-btn
          @click="handleEdit"
          class="white--text text-button ml-4"
          v-btnAuth="['edit-label-translate-internationalization']"
          v-if="disabled"
          fab
          height="40"
          depressed
          small
          color="primary"
        >
          <v-icon class="material-icons">edit</v-icon>
        </v-btn>
      </mrc_ess_iconGroup>
      <v-card-text>
        <mrc_ess_table
          :headers="headerINT"
          hideAddBtn
          :draggableStatus="false"
          :headerName="['headerINT']"
          :paginationOptions="paginationOptions"
          @turnPage="turnPage"
          :loading="loading"
          :slotKey="['language_master_final_key', 'headerINT']"
          :items="items"
        >
          <!-- 表格上部分搜索框 -->
          <template v-slot:search>
            <v-row
              dense
              class="d-flex justify-end align-center"
              style="
                background: white;
                margin: 0;
                border-top-right-radius: 8px;
                border-top-left-radius: 8px;
                padding: 0 16px;
              "
            >
              <!-- style="position:absolute;left:50%;" -->
              <div>
                <v-btn
                  depressed
                  color="primary"
                  icon
                  fab
                  width="32px"
                  height="32px"
                  small
                  @click="addandremove(-1)"
                >
                  <v-icon class="material-icons">keyboard_arrow_left</v-icon>
                </v-btn>
                <v-btn
                  fab
                  :class="deeserts.length > 1 ? 'mr-3' : ''"
                  active-class="asa"
                  x-small
                  :style="{
                    'background-color':
                      index == currentIndex ? '#dee0f5' : '#fff',
                    color: 'var(--main-color)',
                  }"
                  type="button"
                  depressed
                  v-for="(item, index) in deeserts"
                  :key="index"
                  @click="currentIndex = index"
                >
                  <span class="text-button">{{ index + 1 }}</span>
                </v-btn>
                <v-btn
                  icon
                  depressed
                  color="primary"
                  fab
                  width="32px"
                  height="32px"
                  small
                  @click="addandremove(+1)"
                >
                  <v-icon class="material-icons">keyboard_arrow_right</v-icon>
                </v-btn>
              </div>
              <mrc_ess_advanceFilterAndSearchInput
                v-model="systemSeniorQueryString"
                @success="
                  turnPage({ cpage: 1, pagesize: $store.state.pageSize })
                "
                :systemFieldMeta="systemFieldMeta"
              ></mrc_ess_advanceFilterAndSearchInput>
            </v-row>
          </template>

          <!-- 头部插槽 -->
          <template v-slot:header.headerINT="{ item }">
            <div class="d-flex">
              <div
                style="flex: 1"
                v-for="(item1, index) in deeserts[currentIndex]"
                :key="index"
              >
                {{ item1.language_name }}
              </div>
            </div>
          </template>
          <template v-slot:item.headerINT="{ item }">
            <div class="d-flex">
              <div
                style="flex: 1"
                v-for="(item1, index) in deeserts[currentIndex]"
                :key="index"
              >
                {{ item[item1.language_code] }}
              </div>
            </div>
          </template>

          <template v-slot:item.language_master_final_key="{ item }">
            <span>{{ item.language_master_final_key }}</span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn icon v-if="!disabled" @click="openDialog(item)">
              <v-icon> mdi-pencil </v-icon>
            </v-btn>
            <v-btn
              v-if="!disabled"
              icon
              v-btnAuth="['delete-label-translate-internationalization']"
              @click="deleteItem(item)"
            >
              <v-icon> mdi-delete </v-icon>
            </v-btn>
          </template>
        </mrc_ess_table>
      </v-card-text>
      <!-- 提交 -->
      <mrc_ess_submitBtn
        @cancel="tableCancel"
        hideSuccess
        v-show="!disabled"
        :loading="submitLoading"
        @success="tableSuccess"
      ></mrc_ess_submitBtn>
      <!-- 修改新增的弹窗 -->
      <mrc_ess_myDialog
        v-model="dialogFlag"
        @cancel="dialogCancel"
        :loading="dialogLoading"
        @success="dialogSuccess"
        :title="dialogData.language_master_content"
        width="600"
      >
        <v-card-subtitle class="text-right pa-0">{{
          dialogData.uuid
        }}</v-card-subtitle>
        <v-card-text class="pa-0">
          <v-row>
            <v-col md="12">
              <mrc_ess_input
                :placeholder="$t('label_The_name_of_the')"
                :label="$t('label_The_name_of_the') + '*'"
                :readonly="true"
                background-color="#f5f5f5"
                :disabled="true"
                v-model="dialogData.language_master_final_key"
              ></mrc_ess_input>
            </v-col>
            <!-- <v-col cols="12" sm="12">
            <mrc_ess_input
              placeholder="路径"
              :readonly="true"
              v-model="dialogData.language_version_uuid"
              label="路径*"
            ></mrc_ess_input>
          </v-col> -->
          </v-row>
          <div class="mt-6 mb-4 text-h5 text--secondary">
            {{ $t("label_translation") }}
          </div>
          <div
            style="border: 1px solid #dedede; border-radius: 10px"
            class="rounded-lg px-6 py-4"
          >
            <v-row>
              <v-col
                cols="12"
                v-for="item in language"
                :key="item.value"
                sm="12"
              >
                <!-- 去掉了.trim 2021-01-06 hb -->
                <mrc_ess_input
                  :placeholder="item.text"
                  v-model="dialogData[item.value]"
                  :label="item.text"
                ></mrc_ess_input>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </mrc_ess_myDialog>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import Cookie from "js-cookie";
import {
  uploadFileAll,
  uploadFileUser,
  uploadFileOrg,
} from "@/service/api/upload.js";
import {
  downTemplate,
  uploadHint,
  labelVersionList,
  saveLabelTranslate,
  delNationalData,
} from "@/service/api/internationalization";
import { INT_URL } from "@/utils/constant/index.js";
export default {
  components: {},
  props: {},
  data() {
    return {
      uploadUrl: "",
      model: null,
      currentIndex: 0,
      deeserts: [],
      language_list: [],
      systemFieldMeta: [],
      systemSeniorQueryString: [],
      field_alias_name: null,
      table_alias_name: null,
      dialogLoading: false,
      fn: null,
      uploadLoading: null,
      tableStatus: false,
      resStatus: null,
      submitLoading: false,
      dialogData: {
        language_master_content: "",
        language_version_uuid: "",
      },
      loading: true,
      dialogFlag: false,
      paginationOptions: {
        pagesize: this.$store.state.pageSize,
        cpage: 1,
        totalcount: 0, //总条数
        totalpage: 0, //总页数
      },
      fields1: [
        { en: "", uuid: "" },
        { zh: "", uuid: "" },
        { as: "", uuid: "" },
      ],
      fields: "asd",
      headers: [],
      items: [],
      versionValue: "",
      labelValue: "",
      client_typeValue: "",
      language: [],
      disabled: false,
    };
  },
  created() {
    this.uploadUrl = INT_URL;
  },
  async mounted() {
    const value = this.$route.params.uuid || this.$store.state.uuid;
    const name =
      this.$store.state.client_type +
      (this.$store.state.version ? "---" + this.$store.state.version : "");
    if (name) {
      this.client_typeValue = this.$store.state.client_type;
      this.versionValue = this.$store.state.version;
    }

    await this.turnPage(this.paginationOptions);
  },
  methods: {
    addandremove(v) {
      let index = this.currentIndex + v;
      if (index < 0) return (this.currentIndex = 0);
      if (index > this.deeserts.length - 1)
        return (this.currentIndex = this.deeserts.length - 1);
      this.currentIndex = index;
    },
    uploadCVS() {},
    downTemp() {
      downTemplate({ module_name: "版本信息模板.xlsx" });
    },
    getlist() {},
    dialogCancel() {},
    handleReturn() {
      this.$router.go(-1);
    },
    handleEdit() {
      this.disabled = !this.disabled;
      this.$set(this.headers, this.headers.length, {
        text: "",
        align: "start",
        sortable: false,
        value: "actions",
      });
    },
    tableCancel() {
      this.$set(this.headers, this.headers.length - 1, {
        text: "",
        align: "start",
        sortable: false,
        value: "",
        width: 0,
      });
      this.disabled = !this.disabled;
      // this.$myConfirm({
      //   content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
      // })
      //   .then(async () => {
      //     this.$set(this.headers, this.headers.length - 1, {
      //       text: '',
      //       align: 'start',
      //       sortable: false,
      //       value: '',
      //       width: 0,
      //     })
      //     this.disabled = !this.disabled
      //     await this.turnPage(this.paginationOptions)
      //   })
      //   .catch(() => {})
    },
    async tableSuccess() {
      this.submitLoading = true;
      this.items.forEach((item) => {
        delete item.created_by;
        delete item.created_utc_datetime;
        delete item.updated_by;
        delete item.updated_utc_datetime;
      });
      const res = await saveLabelTranslate({
        mrbase_sys_language_values: this.items,
      });
      if (res.code == 200) {
        this.$store.commit(
          "newsTips",
          this.$t("message_The_submission_was_successful")
        );
        this.disabled = !this.disabled;
        this.headers.pop();
        this.$set(this.headers, this.headers.length, {
          text: "",
          align: "start",
          sortable: false,
          value: "",
          width: 0,
        });
      }

      this.submitLoading = false;
    },
    cahnge(val) {},
    openDialog(item) {
      this.dialogData = this.$clone(item);
      this.dialogFlag = true;
    },
    deleteItem(item) {
      const index = this.items.indexOf(item);
      this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
        .then(async () => {
          const res = await delNationalData({
            language_master_uuid: item.uuid,
          });
          if (res.code == 200) {
            // this.items.splice(index, 1)
            this.turnPage(this.paginationOptions);
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            });
            await this.turnPage(this.paginationOptions);
          }
        })
        .catch(() => {});
    },
    async dialogSuccess() {
      const index = this.items.findIndex((item) => {
        return item.uuid == this.dialogData.uuid;
      });
      try {
        this.dialogLoading = true;
        const res = await saveLabelTranslate({
          mrbase_sys_language_values: [this.dialogData],
        });
        if (res.code == 200) {
          // this.$store.commit(
          //   'newsTips',
          //   this.$t('message_The_submission_was_successful')
          // )
          this.$Message({
            text: this.$t("message_The_submission_was_successful"),
          });
          this.dialogFlag = false;
          this.$set(this.items, index, this.dialogData);
          // 修改了语言后重置缓存里面的语言数据
          // await this.$store.dispatch('set_languageList', this.$store.state.lang)
        }
        this.dialogLoading = false;
      } catch (err) {
        this.dialogFlag = false;
        this.dialogLoading = false;
      }
    },
    /**
     * @description: 请求table数据
     * @param {type}
     * @return:
     * @author: lwq
     */
    async turnPage({ pagesize, cpage }) {
      this.loading = true;
      const uuids = this.$store.state.version_uuid;
      pagesize ? (this.paginationOptions.pagesize = pagesize) : (pagesize = 20);
      cpage ? (this.paginationOptions.cpage = cpage) : (cpage = 1);
      const res = await labelVersionList({
        client_type: this.client_typeValue,
        uuids,
        // version: this.versionValue,
        pindex: cpage,
        psize: pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      });
      // {zh: '中文'}
      if (res.code == 200) {
        this.deeserts = [];
        for (var i = 0; i < res.data.mrbase_common_language.length; i += 3) {
          //将数组分为三个一组
          this.deeserts.push(res.data.mrbase_common_language.slice(i, i + 3));
        }
        // this.$set(this.paginationOptions, 'totalcount', res.data.total)
        // this.$set(this.paginationOptions, 'totalPage', res.data.totalPage)
        this.paginationOptions.totalcount = res.data.total;
        this.paginationOptions.totalpage = res.data.totalPage;
        this.systemFieldMeta = res.systemFieldMeta;
        this.field_alias_name = res.field_alias_name;
        this.table_alias_name = res.table_alias_name;
        const title = res.data.mrbase_common_language.map((item, index) => {
          return {
            text: item.language_name || "",
            align: "start",
            sortable: false,
            value: item.language_code || "",
            width: 100,
          };
        });
        this.language = title;
        this.headers = [
          {
            text: this.$t("label_id_name_and_path"),
            align: "start",
            sortable: false,
            value: "language_master_final_key",
            width: "200px",
          },
          ...title,
          // {
          //   text: '',
          //   align: 'start',
          //   sortable: false,
          //   value: '',
          //   width: 0
          // }
        ];
        const list = res.data.mrbase_sys_language_master;
        this.items = list;
      }

      this.loading = false;
      if (this.disabled) {
        this.$set(this.headers, this.headers.length, {
          text: "",
          align: "start",
          sortable: false,
          value: "",
          width: 0,
        });
      } else {
        this.$set(this.headers, this.headers.length, {
          text: "",
          align: "end",
          sortable: false,
          value: "actions",
        });
      }
    },
  },
  computed: {
    headerINT() {
      return [
        {
          text: this.$t("label_id_name_and_path"),
          align: "start",
          sortable: false,
          value: "language_master_final_key",
        },
        {
          text: "",
          align: "start",
          sortable: false,
          value: "headerINT",
        },
        {
          text: "",
          align: "end",
          sortable: false,
          value: "actions",
          width: "120",
        },
      ];
    },
  },
  watch: {},
};
</script>

<style scoped>
/* .labelTrans /deep/ table > tbody > tr > td:first-child,
.labelTrans /deep/ table > thead > tr > th:first-child,
.labelTrans /deep/ table > tbody > tr > td:last-child,
.labelTrans /deep/ table > thead > tr > th:last-child {
  position: sticky !important;
  position: -webkit-sticky !important;
  z-index: 2 !important;
  background: white !important;
}
.labelTrans /deep/ table > thead > tr > th:first-child,
.labelTrans /deep/ table > thead > tr > th:last-child {
  z-index: 3 !important;
}

.labelTrans /deep/ table > tbody > tr > td:first-child,
.labelTrans /deep/ table > thead > tr > th:first-child {
  left: 0 !important;
  width: 200px;
  word-break: break-all;
  white-space: pre-wrap;
}
.labelTrans /deep/ table > tbody > tr > td:last-child,
.labelTrans /deep/ table > thead > tr > th:last-child {
  right: 0 !important;
} */
.asa {
  background-color: red;
}
</style>
